import classnames from 'classnames';
import { IoMdTime } from 'react-icons/io';
import { CustomAvatarProps, TmdxAvatar } from '@ds';
import { convertToTimezoneOffset } from '@/utils/helpers';

type FacilityCardProps = {
  label: string;
  isHospital?: boolean;
  subLabel: string;
  image?: string;
  orTime?: string;
  etaTime?: string;
  etaLabel?: string;
  etaOffsetTimeMs?: number;
  avatarProps?: CustomAvatarProps;
};

const FacilityCard = ({
  isHospital = false,
  label,
  subLabel,
  image,
  orTime,
  etaTime,
  etaLabel = 'ETA',
  etaOffsetTimeMs,
  avatarProps,
}: FacilityCardProps) => (
  <div className="bg-base-60 p-2 pr-2 pl-20 rounded-xl w-full">
    <div className="flex flex-row items-center gap-1">
      <TmdxAvatar size="lg" radius="lg" type="facility" src={image} {...avatarProps} />
      <div className="w-full flex items-center justify-between">
        <div className="flex flex-col shrink max-w-60 py-1">
          <div className="text-s-r text-base-10">{subLabel}</div>
          <div className="text-m-m truncate">{label}</div>
        </div>
        <div className="flex flex-col justify-between">
          {etaTime && (
            <div
              className={classnames('flex flex-row items-center gap-1 shrink-0', isHospital ? 'order-2' : 'order-1')}
            >
              <IoMdTime size={16} />
              <div className="flex flex-row gap-2 items-center">
                <span className="text-s-sb">{etaLabel}</span>
                <span className="text-s-sb">{etaTime}</span>
              </div>
              {!!etaOffsetTimeMs && (
                <span className="flex items-center p-1 bg-danger-70 rounded text-s-sb text-base-10">
                  {`${convertToTimezoneOffset(etaOffsetTimeMs)}h`}
                </span>
              )}
            </div>
          )}
          {orTime && (
            <div
              className={classnames('flex flex-row items-center gap-1 shrink-0', isHospital ? 'order-1' : 'order-2')}
            >
              <IoMdTime size={16} />
              <div className="flex flex-row gap-2 items-center">
                <span className="text-s-sb">OR</span>
                <span className="text-s-sb">{orTime}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default FacilityCard;
